import { CompanyListDTO } from './../../../../models/company.model';
import { VATRateService } from './../../../../services/VATRate.service';
import { UtilityService } from './../../../../services/utility.service';
import { LookupService } from './../../../../services/lookup.service';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Product_Type, ProductDTO } from '../../../../models/product.model';
import { DialogService } from '../../../../services/dialog.service';
import { GlobalService } from '../../../../services/global.service';
import { ProductService } from '../../../../services/product.service';
import { LookupDTO } from '../../../../models/lookup.model';

@Component({
  selector: 'app-add-products',
  templateUrl: './add-products.component.html',
  styleUrls: ['./add-products.component.scss']
})
export class AddProductsComponent implements OnInit {

  DisableRedirectAfterSave: boolean = false;
  idLookupEntity: number = null;
  retriviedLookupVatRate: Array<LookupDTO> = new Array<LookupDTO>();

  currentCompany: CompanyListDTO;

  productForm: UntypedFormGroup;
  product: ProductDTO = new ProductDTO();
  utilityService = UtilityService;
  product_typeEnumArray = Array<any>();
  
  measureUnitLookupColumns: any[] = [
    { dataField: 'FullObject.Code', caption: 'GENERIC_FIELDS.CODE', minWidth: 100 },
    { dataField: 'Label', caption: 'GENERIC_FIELDS.DESCRIPTION', minWidth: 200 }
  ];

  prefilledName: string = null;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private activateRoute: ActivatedRoute,
    private productService: ProductService,
    private utilService: UtilityService,
    private lookupService: LookupService,
    private vatRateService: VATRateService) {
  }

  async ngOnInit() {
    let currentID = this.idLookupEntity == 0 ? null : this.idLookupEntity != null ? this.idLookupEntity : Number(this.activateRoute.snapshot.params["id"] != null) ? Number(this.activateRoute.snapshot.params["id"]) : null;
    this.currentCompany = GlobalService.getCurrentCompany();
    this.retriviedLookupVatRate = await this.vatRateService.getAllLookupData(GlobalService.getUsedCompany());
    this.product_typeEnumArray = this.utilService.GetEnumArray(Product_Type, true, this.translate, "ENUMS.PRODUCT_TYPE.");
    //Se regime forfettario, controllo che non sia stato inserito un aliquota
    // //TODO: trovare un modo per incapsulare tutti i controlli per il regime forefettario
    // if (this.currentCompany != null && this.currentCompany.FK_CommercialProductInUse == 4) {
    //   this.retriviedLookupVatRate = this.retriviedLookupVatRate.filter(x => x.FullObject.Rate == 0);
    // }
    // L'ID è presente, entro in modifica ricostruendo i dati dell'utente
    if (currentID != null) {

      this.productService.getProductByID(currentID)
        .then((res) => {
          this.product = res;
          this.createForm();
          if (this.activateRoute.snapshot.params["clona"] != null) {
            this.cloneProduct();
          }
        })
        .catch((err) => {
          DialogService.Error(err.message);
        });
    }
    else {
      // L'ID non è presente, entro in aggiunta
      this.product = new ProductDTO();
      this.product.Type = Product_Type.PRODUCT;
      this.product.FK_Company = GlobalService.getUsedCompany();
      if (this.prefilledName) {
        this.product.Name = this.prefilledName;
      }
      this.createForm();
    }
  }

  /**
   * Creazione del form dati
   **/
  createForm() {
    this.productForm = this.formBuilder.group({
      code: [this.product.Code],
      name: [this.product.Name, Validators.required],
      measureUnit: [this.product.MeasureUnit, null],
      price: [this.product.Price, null],
      vatRate: [this.product.VatRate?.ID || null, null],
      type: [this.product.Type, Validators.required]
    });
  }

  /**
   * Metodo per la clonazione di un prodotto che si occupa di settare a 0 l'ID e rendere null il codice del prodotto da clonare
   */
  cloneProduct() {
    this.product.ID = 0;
    this.product.Code = null;
    this.product.IsStamp = false;
    this.product.FK_Company = GlobalService.getUsedCompany();    
  }

  /**
   * Salvataggio dei dati
   **/
  save() {
    if (this.productForm.invalid === true)
      return;

    this.productService.saveProduct(this.product)
      .then((res) => {
        if (this.DisableRedirectAfterSave == false) {
          DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"));
          this.exit();
        } else if (this.lookupService.lookupAddingComplete != undefined) {
          this.lookupService.lookupAddingComplete.emit(res);
        }
      })
      .catch((err) => {
        DialogService.Error(err.message);
      })
  }

  /**
   * Annulla l'operazione di aggiunta
   **/
  exit() {
    if (this.DisableRedirectAfterSave == false) {
      this.router.navigate(['/registry/list-products']);
    } else if (this.lookupService.lookupAddingComplete != undefined) {
      this.lookupService.lookupAddingComplete.emit(null);
    }
  }

}
